
import { AloDbMesureType } from '@/models/alodb/AloDbMesureType'
import { FilterMesureType } from '@/models/filter/FilterMesureType'

export interface IMesureTypeState {
    status:string
    mesureTypes: Array<AloDbMesureType>
    modifiedAdmMesureType: AloDbMesureType
    originalAdmMesureType: AloDbMesureType
    mesureTypeLoading: boolean
    adminFilter: FilterMesureType
}
  
const state:IMesureTypeState = { 
    status: '',
    mesureTypes: [],
    modifiedAdmMesureType: new AloDbMesureType(),
    originalAdmMesureType: new AloDbMesureType(),
    mesureTypeLoading:false,
    adminFilter: new FilterMesureType()
}
  
export default state